export default "__VITE_ASSET__264bb299__"